import React from 'react';
import defaultLocales from 'globals/locales/default';
import FsDefaultDialog from 'ui-elements/modals/FsDefaultDialog';
import FsBillingInfoForm from 'ui-elements/forms/FsBillingInfoForm';
import { useAppContext } from 'contexts/AppContext';

interface BillingInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BillingInfoModal: React.FC<BillingInfoModalProps> = ({
  isOpen,
  onClose,
}) => {
  const {
    billingInfo: { getBillingDetailsSnapshot },
  } = useAppContext();

  return (
    <FsDefaultDialog
      disableBackdropClick
      disableEscapeKeyDown
      title={defaultLocales.billingInfo}
      isOpen={isOpen}
      fullWidth
      maxWidth="sm"
      onClose={onClose}
    >
      <FsBillingInfoForm onClose={onClose} {...getBillingDetailsSnapshot()} />
    </FsDefaultDialog>
  );
};

export default BillingInfoModal;
